import {
  Container,
  Text,
  Box,
  Button,
  Center,
  Flex,
  Spacer
} from "@chakra-ui/react";
import { Divider } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../constants/api";
import { useVoiceprintStore } from "../store";
import EnrollmentInfo from "./EnrollmentInfo";
import InfoCardAccordion from "./InfoCardAccordian";

const AddNew = ({ setProgress, accessToken }) => {
  const { setCurrentStep, currentStep } = useVoiceprintStore();
  const [data, setData] = useState([]);

  const fetchEnrolledVoiceprints = () => {
    const response = axios
      .get(`${BASE_URL}/voice/enroll/data/user`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        console.log("data--------------->", res.data);
        setData(res.data);
      })
      .catch(err => {
        console.error("Error getting enrol user data ", err);
      });
  };

  useEffect(() => {
    fetchEnrolledVoiceprints();
  }, []);

  return (
    <>
      <Box p={5} w="100%" mb="8%">
        <Text color="#1b1c1e" fontSize="xl" mr="12%">
          Voice Biometric
        </Text>
      </Box>
      <Box></Box>
      {data.length !== 0 ? (
        data.map(data => (
          <EnrollmentInfo
            phoneNumber={data.external_uid}
            speechDuration={data.speech_duration}
            setProgress={setProgress}
            accessToken={accessToken}
            refetch={fetchEnrolledVoiceprints}
          />
        ))
      ) : (
        <Text fontSize="xl" color="#515151">
          No Enrolled User
        </Text>
      )}
      <Button
        size="lg"
        mt="10"
        w="100%"
        color="white"
        bgColor="black"
        onClick={() => setCurrentStep("details")}
      >
        Create a Voiceprint
      </Button>
    </>
  );
};

export default AddNew;
